<mat-card class="w-full" appearance="outlined">
  <img mat-card-image src="{{playlist.thumbnail}}" alt="Thumbnail of playlist">
  <mat-card-content>
  </mat-card-content>
  <mat-card-footer class="p-2">
    <mat-card-title>
      <b>{{ playlist.title }}</b>
    </mat-card-title>
    <mat-card-subtitle>
      <p class="text-sm" >{{ playlist.id }}</p>
    </mat-card-subtitle>
    <p>{{ playlist.uploader.name }} ({{ playlist.uploader.id }})</p>
    <div class="w-full flex flex-row justify-between">
      <button matButton [routerLink]="['/videos']" [queryParams]="{id: playlist.id}">View</button>
      <button matButton (click)="updatePlaylist(playlist.id)">Update</button>
    </div>
  </mat-card-footer>
</mat-card>